<p>dashboard-category-chart-settings works!</p>
